// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3505":"a5cd6943","4127":"976aae30","5027":"bdbd853d","6375":"7c467cf6","7684":"8b85c570","7850":"ec9201e1","8272":"fda67240","8563":"ee8f7584","9532":"ee8f7584"}[chunkId] + ".chunk.css";
};